export const VARIANTS = {
  DEFAULT: 'default',
  COMPACT: 'compact',
}
